module.exports = __webpack_public_path__ + "images/ivp.17b6a27d.webp";